export type Category = 'mobile-living' | 'off-grid-homes' | 'boat-living' | 'camping';

// Keep Language type for legacy data files
export type Language = 'en' | 'sv' | 'de' | 'fr' | 'es' | 'pt';

// Article type that supports legacy format with translations
export interface BookRecommendation {
  title: string;
  author: string;
  description: string;
}

export interface Article {
  id: string;
  slug: string;
  category: Category;
  image: string;
  publishedAt: string;
  updatedAt?: string;
  tags: string[];
  bookRecommendation?: BookRecommendation;
  content: {
    en: {
      title: string;
      excerpt: string;
      body: string;
    };
    [key: string]: {
      title: string;
      excerpt: string;
      body: string;
    };
  };
}

export interface CategoryInfo {
  id: Category;
  icon: string;
  name: string;
  description: string;
}

// Helper to get English content from article - used during transition
export const getEnglishContent = (article: Article): { title: string; excerpt: string; body: string } => {
  return article.content.en;
};
